import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import AnimatedTransition from '../AnimatedTransition/AnimatedTransition';

import { BET_LEGEND_ITEMS } from './bet-tooltip.constants';
import { IBetTooltipProps } from './bet-tooltip.types';

export const BetTooltip = ({
  showTip,
  rawBet,
  onClose,
  containerClassName,
  className,
}: IBetTooltipProps) => {
  const { t } = useTranslation();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onClose?.();
      }
    };

    if (showTip) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showTip, onClose]);

  return (
    <AnimatedTransition asFragment show={showTip} data-testid="bet-tooltip">
      <div ref={ref} className={containerClassName}>
        <div className={className}>
          {BET_LEGEND_ITEMS.map(({ label, value }, i) => (
            <p key={i} className="text-white">
              {label} <span className="opacity-60">- {value}</span>
            </p>
          ))}
          <p className="mt-1 w-full border-t border-gray-border pt-1 text-start text-white">
            {t('pages.liveGamesSection.bet')} <span className="opacity-60">- {rawBet}</span>
          </p>
        </div>
      </div>
    </AnimatedTransition>
  );
};
